import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  createUrlTreeFromSnapshot,
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngxs/store';
import { Authorize } from 'src/app/models/authorize.model';
import { Login } from 'src/app/state/snappstay.action';
import { SnappstayState } from 'src/app/state/snappstay.state';

export const authGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const jwtHelper = new JwtHelperService();
  const authorize = store.selectSnapshot<Authorize | undefined>(SnappstayState.Authorize);
  const isAuthenticated = authorize && authorize.token && !jwtHelper.isTokenExpired(authorize.token);
  if (isAuthenticated) {
    return true;
  }
  return router.createUrlTree(['/']);
};
